import React from 'react';
import CurrencyDropdown from '../../../containers/CurrencyDropdown';
import { formatNewMoney } from '../../../utils/formatter';
import './CurrencyChangeRow.scss';

const CurrencyChangeRow = ({
  formData,
  handleInvoiceCurrencyChange,
  handleInvoiceExchangeRateChange,
  className = '',
  disabled = false,
  disableExchangeRate = false,
  obligationCurrency = null, // For UF/UTM display
  showReconciliationText = false, // Show "Este será el monto que se conciliará" text
  exchangeRateDate = null // Date to display in the exchange rate label
}) => {
  // Calculate Valor Bruto Local (exchange rate * amount, no decimals)
  const valorBrutoLocal = formData.invoiceExchangeRate && formData.originalAmount
    ? Math.round(parseFloat(formData.invoiceExchangeRate) * parseFloat(formData.originalAmount))
    : 0;

  // For UF/UTM, show "Chile (UF)" or "Chile (UTM)" in the MONEDA field
  const displayCurrency = obligationCurrency === 'UF' || obligationCurrency === 'UTM'
    ? `Chile (${obligationCurrency})`
    : (formData.invoiceCurrency || '');

  return (
    <div 
      style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: '16px', marginBottom: '16px' }}
      className={className}
    >
      <div className="currency-change-field">
        <label className="currency-change-label" htmlFor="currency-change-currency">MONEDA</label>
        {obligationCurrency === 'UF' || obligationCurrency === 'UTM' ? (
          // Display as text input when UF/UTM is selected
          <input
            id="currency-change-currency"
            type="text"
            value={displayCurrency}
            disabled
            readOnly
            className="currency-change-input currency-change-input-disabled"
            style={{
              width: '100%',
              padding: '12px 16px',
              border: '1px solid #d1d9e0',
              borderRadius: '8px',
              fontSize: '14px',
              color: '#3C4B64',
              backgroundColor: '#f9fafb',
              cursor: 'not-allowed'
            }}
          />
        ) : (
          <CurrencyDropdown
            id="currency-change-currency"
            placeholder="Seleccione moneda"
            value={formData.invoiceCurrency || ''}
            onChange={handleInvoiceCurrencyChange}
            className="w-100"
            disabled={disabled}
          />
        )}
      </div>
      <div className="currency-change-field">
        <label className="currency-change-label" htmlFor="currency-change-exchange-rate">
          TIPO DE CAMBIO{exchangeRateDate ? ` (Fecha: ${exchangeRateDate})` : ''}
        </label>
        <input
          id="currency-change-exchange-rate"
          type="number"
          step="0.01"
          min="0"
          value={formData.invoiceExchangeRate || ""}
          onChange={handleInvoiceExchangeRateChange}
          placeholder="0.00"
          inputMode="decimal"
          disabled={disableExchangeRate}
          readOnly={disableExchangeRate}
          className={disableExchangeRate ? "currency-change-input currency-change-input-disabled" : "currency-change-input"}
        />
      </div>
      <div className="currency-change-field">
        <label className="currency-change-label" htmlFor="currency-change-valor-bruto-local">VALOR BRUTO LOCAL</label>
        <input
          id="currency-change-valor-bruto-local"
          type="text"
          value={formatNewMoney(valorBrutoLocal)}
          disabled
          readOnly
          placeholder="0"
          className="currency-change-input currency-change-input-disabled"
        />
        {showReconciliationText && (
          <div style={{ 
            fontSize: '11px', 
            color: '#6B7280', 
            marginTop: '4px',
            fontStyle: 'italic'
          }}>
            Este será el monto que se conciliará
          </div>
        )}
      </div>
    </div>
  );
};

export default CurrencyChangeRow;

